const monthNames = ["Января", "Февраля", "Марта", "Апреля", "Мая", "Июня",
    "Июля", "Августа", "Сентября", "Октября", "Ноября", "Декабря"
];

const getMonthName = (index) => {
    return monthNames[index];
} ;

export default getMonthName;